/**
 * @author Ketan Shetye
 * @created 2025-10-25
 * @description common icon component
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonIconData } from './common-icon.component.model';

@Component({
  selector: 'wm-common-icon',
  standalone:false,
  templateUrl: './common-icon.component.html',
  styleUrls: ['./common-icon.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class CommonIconComponent {
  @Input({required:true}) data:CommonIconData={
    iconName:''
  };
  //added by priya 23-12-2025 
  get isImage(): boolean {
    return !!this.data.imageSrc;
  }
  //end by priya 23-12-2025 

  get isSvgIcon(): boolean {
    return this.data.iconName?.endsWith('Icon');
  }

}
